// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hyperlink {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.text-secondary-18 {\n  color: #af6708;\n}\n.border-secondary-39 {\n  border: 1px solid #f3af54;\n}\n.border-green {\n  border: 1px solid #2cb484;\n}\n.bg-custom-green {\n  background-color: #f0fcf4;\n}", ""]);
// Exports
module.exports = exports;
